export const sanitizeText = text => {
  if (!text) return ""

  return text
    ?.replace(/<[^>]*>/g, "") // Remove HTML tags
    ?.replace(/&amp;/g, "&") // Convert &amp; to &
    ?.replace(/&lt;/g, "<") // Convert &lt; to <
    ?.replace(/&gt;/g, ">") // Convert &gt; to >
    ?.replace(/&quot;/g, '"') // Convert &quot; to "
    ?.replace(/&#039;/g, "'") // Convert &#039; to '
    ?.replace(/&#39;/g, "'") // Convert &#39; to '
    ?.replace(/&nbsp;/g, " ") // Convert &nbsp; to space
    ?.trim()
}
